import { Button, Checkbox, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import IntList from "./IntList";

const IntAuth = () => {
  const correctPassword = "imightbehannan";
  const [password, setPassword] = useState(
    localStorage.getItem("password") || ""
  );
  const [mainPassword, setMainPassword] = useState("")
  const [rememberMe, setRememberMe] = useState(false);
  const handleSubmit = () => {
    if (rememberMe) {
      localStorage.setItem("password", password);
    }else{
        localStorage.setItem("password", "");
    }
    setMainPassword(password)
  };
  useEffect(() => {
    if (localStorage.getItem("password")==correctPassword) {
        setRememberMe(true)
    }
  

  }, [])
  
  return (
    <>
      {mainPassword == correctPassword ? (
        <IntList />
      ) : (
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
          }}
        >
          <div style={{ width: "30vw" }}>
            <h2 style={{ marginBottom: "40px" }}>Prove That you are Hannan</h2>
            <TextField
              fullWidth
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Checkbox
                checked={rememberMe}
                onChange={(e) => {
                  setRememberMe(e.target.checked);
                }}
                title="landkslda"
              />

              <p>Remember me</p>
            </div>
            <Button variant="outlined" onClick={handleSubmit}>Enter</Button>
          </div>
        </div>
      )}
    </>
  );
};

export default IntAuth;
